import React from "react";
import { useColorTokens } from "@tvg/design-system";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const SVG = styled.svg<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  animation: ${pulseAnimation} 1.25s infinite;
  margin-bottom: ${({ isMobile }) => (isMobile ? "0" : "16px")};
`;

const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorTokens.background.secondary};
`;

interface TrackHeaderLoadingProps {
  isMobile: boolean;
}

const DesktopLoading = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="158.98"
    fill="none"
    isMobile={false}
  >
    <rect width="100%" height="158.98" fill="transparent" />
    <rect
      y="24"
      width="120"
      height="20"
      rx="1"
      fill="white"
      fillOpacity="0.1"
    />
    <rect y="77" width="32" height="20" rx="2" fill="white" fillOpacity="0.1" />
    <rect
      x="44"
      y="77"
      width="33%"
      height="20"
      rx="1"
      fill="white"
      fillOpacity="0.1"
    />
    <rect
      y="115"
      width="100%"
      height="44"
      rx="4"
      fill="white"
      fillOpacity="0.1"
    />
  </SVG>
);

const MobileLoading = () => {
  const backgroundSecondary = useColorTokens("background.secondary");

  return (
    <MobileContainer>
      <SVG
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="173"
        viewBox="0 0 375 173"
        fill="none"
        preserveAspectRatio="none"
        isMobile
      >
        <rect width="375" height="173" fill="transparent" />
        <rect
          x="12"
          y="113"
          width="125"
          height="44"
          rx="2"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="145"
          y="113"
          width="218"
          height="44"
          rx="2"
          fill="white"
          fillOpacity="0.1"
        />
        <g clipPath="url(#clip0_4619_26526)">
          <g clipPath="url(#clip1_4619_26526)">
            <rect
              width="48"
              height="48"
              transform="translate(145 49)"
              fill="white"
              fillOpacity="0.1"
            />
          </g>
          <g clipPath="url(#clip2_4619_26526)">
            <rect
              width="48"
              height="48"
              transform="translate(193 49)"
              fill="white"
              fillOpacity="0.1"
            />
          </g>
          <g clipPath="url(#clip3_4619_26526)">
            <rect
              width="48"
              height="48"
              transform="translate(241 49)"
              fill="white"
              fillOpacity="0.1"
            />
          </g>
          <g clipPath="url(#clip4_4619_26526)">
            <rect
              width="48"
              height="48"
              transform="translate(289 49)"
              fill="white"
              fillOpacity="0.1"
            />
          </g>
          <g clipPath="url(#clip5_4619_26526)">
            <rect
              width="48"
              height="48"
              transform="translate(337 49)"
              fill="white"
              fillOpacity="0.1"
            />
          </g>
          <path
            d="M375 49H331V97H375V49Z"
            fill="url(#paint0_linear_4619_26526)"
          />
        </g>
        <rect
          x="12"
          y="49"
          width="125"
          height="48"
          rx="4"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="12"
          y="18"
          width="20"
          height="12.5"
          rx="2"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="44"
          y="14"
          width="319"
          height="20"
          rx="1"
          fill="white"
          fillOpacity="0.1"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4619_26526"
            x1="375"
            y1="73"
            x2="331"
            y2="73"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={backgroundSecondary} />
            <stop offset="1" stopColor={backgroundSecondary} stopOpacity="0" />
          </linearGradient>
          <clipPath id="clip0_4619_26526">
            <path
              d="M145 53C145 50.7909 146.791 49 149 49H375V97H149C146.791 97 145 95.2091 145 93V53Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_4619_26526">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(145 49)"
            />
          </clipPath>
          <clipPath id="clip2_4619_26526">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(193 49)"
            />
          </clipPath>
          <clipPath id="clip3_4619_26526">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(241 49)"
            />
          </clipPath>
          <clipPath id="clip4_4619_26526">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(289 49)"
            />
          </clipPath>
          <clipPath id="clip5_4619_26526">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(337 49)"
            />
          </clipPath>
        </defs>
      </SVG>
    </MobileContainer>
  );
};

const TrackHeaderLoading = ({ isMobile }: TrackHeaderLoadingProps) =>
  isMobile ? <MobileLoading /> : <DesktopLoading />;

export default TrackHeaderLoading;
